var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtDreaptaSus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 94,
    viewBox: "0 0 85 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 94L43 47L0 47",
    stroke: "black",
    strokeWidth: 3.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtDreaptaSus);
export default __webpack_public_path__ + "static/media/colt_dreapta_sus.f391ee88443842e3dada69806d920081.svg";
export { ForwardRef as ReactComponent };